var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbnail1B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 225,
    viewBox: "0 0 328 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 328,
    height: 225,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50732,
    y: 18.8306,
    width: 57.0435,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 133.102,
    y: 18.8306,
    width: 57.0435,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 71.3042,
    y: 18.8306,
    width: 57.0435,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 194.898,
    y: 18.8306,
    width: 57.0435,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50732,
    y: 164.257,
    width: 48.9092,
    height: 13.125,
    stroke: "#CCCCCC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 58.416,
    y: 164.257,
    width: 260.076,
    height: 13.125,
    stroke: "#CCCCCC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50732,
    y: 156.665,
    width: 48.9092,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 58.416,
    y: 156.665,
    width: 260.076,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50732,
    y: 134.03,
    width: 48.9092,
    height: 13.125,
    stroke: "#CCCCCC"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 107.325,
    y: 134.03,
    width: 48.9092,
    height: 13.125,
    stroke: "#CCCCCC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 58.416,
    y: 134.03,
    width: 48.9092,
    height: 13.125,
    stroke: "#CCCCCC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 156.234,
    y: 134.03,
    width: 48.9092,
    height: 13.125,
    stroke: "#CCCCCC"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 205.143,
    y: 134.03,
    width: 48.9092,
    height: 13.125,
    stroke: "#CCCCCC"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50732,
    y: 126.438,
    width: 48.9092,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 107.325,
    y: 126.438,
    width: 48.9092,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 58.416,
    y: 126.438,
    width: 48.9092,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 156.234,
    y: 126.438,
    width: 48.9092,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 205.143,
    y: 126.438,
    width: 48.9092,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 282.059,
    y: 134.03,
    width: 36.4339,
    height: 13.125,
    stroke: "#CCCCCC"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 254.052,
    y: 134.03,
    width: 28.0061,
    height: 13.125,
    stroke: "#CCCCCC"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 282.059,
    y: 126.438,
    width: 36.4339,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 254.052,
    y: 126.438,
    width: 28.0061,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50732,
    y: 31.0181,
    width: 308.986,
    height: 1.875,
    fill: "#E0E0E0"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50732,
    y: 42.2681,
    width: 128.323,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50732,
    y: 63.9221,
    width: 115.664,
    height: 53.0063,
    stroke: "#CCCCCC"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50732,
    y: 56.3306,
    width: 115.664,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 254.052,
    y: 63.9221,
    width: 64.4401,
    height: 53.0063,
    stroke: "#CCCCCC"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 189.612,
    y: 63.9221,
    width: 64.4401,
    height: 53.0063,
    stroke: "#CCCCCC"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 125.172,
    y: 63.9221,
    width: 64.4401,
    height: 53.0063,
    stroke: "#CCCCCC"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 254.052,
    y: 56.3306,
    width: 64.4401,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 189.612,
    y: 56.3306,
    width: 64.4401,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 125.172,
    y: 56.3306,
    width: 64.4401,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50732,
    y: 9.45557,
    width: 95.0725,
    height: 4.6875,
    fill: "#E0E0E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnail1B);
export default __webpack_public_path__ + "static/media/thumbnail-1-b.e1af908ae0c5074dbaf4f0ceadd51c37.svg";
export { ForwardRef as ReactComponent };